<div class="mini-horizontal-stack-chart" [pTooltip]="makeTooltip()">
  @for (item of items; track item; let i = $index) {
    <div class="mini-horizontal-stack-chart-item" [style.background-color]="item.color || 'inherited'" [style.color]="item.textColor || 'inherited'" [style.width.%]="percentages[i]">
      @if (percentages[i] > 10) {
        <div class="label">{{ item.value }}</div>
      }
    </div>
  }
</div>